import React, { ReactNode } from 'react';
import { DraggableProvided } from 'react-beautiful-dnd';

export const NonDraggableWrapper: React.FC<{
    provided: DraggableProvided;
    children: ReactNode;
}> = ({ provided, children }) => (
    <div
        data-rbd-drag-handle-context-id={provided.dragHandleProps?.['data-rbd-drag-handle-context-id']}
        data-rbd-drag-handle-draggable-id='nonDragableArea'
        style={{ cursor: 'auto' }}
    >
        {children}
    </div>
);